import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  GetTodaysDateINdmy } from "../../../../../CommonFunction/GetTodaysDate";
import { GetUserInfo, getCompanyCode, getUserName } from "../../../../../CommonFunction/GetUserInfo";
import { convertToISO } from "../../../../../CommonFunction/IsoDateTime";
import PortalFooter from "../../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../ToastComponent/RectHotToast";
import "../.././FormComponent.scss";
import useKeyDown from "../../AddLoad/text";
import data from "./AddPendingPODs.config";
import AddPendingPODsSection from "./AddPendingPODsSection/AddPendingPODsSection";
const updatePendingToCollected = gql`
  mutation pendingToCollected($id: ID!, $POD_ManagementInput: CreatePOD_ManagementInput!) {
    editPOD_Management(id: $id, POD_ManagementInput: $POD_ManagementInput) {
      Status
    }
  }
`;

const getPodDataByID = gql`
  query POD_Management($ID: ID!) {
    POD_Management(ID: $ID) {
      _id
      Vehicle_Number {
        _id
        Vehicle_No
      }
      Booking_Id
      POD_Copy_Front
      POD_Copy_Back
      Damage_Or_Breakage

      UserId {
        _id
        FullName
      }
      LoadId {
        _id
        Unique_Id
      }
      Invoice_Copy
      Driver_Name
      Driver_Number

      LR_No
    }
  }
`;
const formField = {
  POD_Sent_To: "",
  POD_Sent_By: getUserName(),
  POD_Sent_Date: GetTodaysDateINdmy(),
};
const AddPendingPODs = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction, id }) => {
  const [PendingToCollected, { loading }] = useMutation(updatePendingToCollected);
  const [toggle, settoggle] = useState(false);
  const [alldata, setalldata] = useState({});
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const FormData = useSelector((store) => store.FormFieldData);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Penging_PODs?.Selected_Row;
  const submitFunctionCalled = useRef(true);
  const [FormField, setFormField] = useState({ ...formField });
  const [getPODData] = useLazyQuery(getPodDataByID, { fetchPolicy: "network-only" });
  const dispatch = useDispatch();
  useEffect(() => {
    getCompanyCode().then((res) => {
      dispatch({
        type: "SearchMasterData",
        payload: {
          CompId: { _id: res.id },
        },
      });
    });
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      getPODData({
        variables: {
          ID: id,
        },
      })
        .then(({ data }) => {
          let PODData = { ...data?.POD_Management };
          dispatch({
            type: "SearchMasterData",
            payload: {
              LoadId: { _id: PODData?.LoadId?._id },
              UserId: { _id: PODData?.UserId?._id },
              Vehicle_Number: { _id: PODData?.Vehicle_Number?._id },
            },
          });
          if (PODData && PODData.LoadId) {
            PODData.LoadId = PODData?.LoadId?.Unique_Id;
          }
          if (PODData && PODData.UserId) {
            PODData.UserId = PODData?.UserId?.FullName;
          }
          if (PODData && PODData.Vehicle_Number) {
            PODData.Vehicle_Number = PODData?.Vehicle_Number?.Vehicle_No;
          }
          PODData.Collected_Date = GetTodaysDateINdmy();
          PODData.Collected_By = getUserName();
          setAllFieldsData(PODData);
        })
        .catch((err) => console.log(err.message));
    }
  }, [fielddata, TypeOfPortal]);

  useEffect(() => {
    setalldata(FormData.fielddata);
  }, [FormData]);
  useEffect(() => {
    setSelectedRows(fielddataRedux?.Penging_PODs?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  const submit = async () => {
    let data = {};
    for (let key in alldata) {
      if (key !== "POD_Details") {
        data = {
          ...data,
          ...alldata[key],
        };
      }
    }
    if (TypeOfPortal === "Edit") {
    } else if (TypeOfPortal === "Delete") {
    } else if (TypeOfPortal === "Update Pending POD") {
      data = { ...data, Status: "Pending For Process" };
      data.Branch = FormData?.masterData?.Branch?._id;
      let userId = GetUserInfo();
      data.Collected_By = userId?.userDetails[0]?._id;
      data.Collected_Date = convertToISO(data.Collected_Date);
      data.UserId = FormData?.masterData?.UserId?._id;
      data.LoadId = FormData?.masterData?.LoadId?._id;
      data.Vehicle_Number = FormData?.masterData?.Vehicle_Number?._id;
      await PendingToCollected({
        variables: {
          id: allFieldsData._id,
          POD_ManagementInput: data,
        },
      })
        .then((res) => {
          SuccessToast("POD Collected...!");
          dispatch({ type: "Refetch", payload: true });
          Closeformfunction();
        })
        .catch((err) => ErrorToast(err.message));
    }
  };
  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
    setFormField({ ...formField });
  };

  const HandleKeyDownf3 = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.keyCode === 27) {
        return Closeformfunction();
      } else if (event.keyCode === 114) {
        if (submitFunctionCalled.current) {
          submitFunctionCalled.current = false;
          return;
        }
      }
    },
    [Closeformfunction, submit]
  );
  useKeyDown(HandleKeyDownf3);

  return (
    <div>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal}
        TypeOfId={"Account Id :"}
        id={allFieldsData && allFieldsData.id ? allFieldsData.id : ""}
      >
        <div className="formContainer">
          {data &&
            data.map((e) => {
              return (
                <>
                  <AddPendingPODsSection
                    inputfields={e.fields}
                    Type={e.name}
                    fielddata={allFieldsData}
                    TypeOfPortal={TypeOfPortal}
                  />
                </>
              );
            })}
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={submitType}
          SaveAndClose={() => {
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          loadingState={loading}
        />
      </Reactportal>
    </div>
  );
};
export default AddPendingPODs;
